module.exports = __webpack_public_path__ + "img/Artboard – 2 (2).2f808367.png";